<template>
    <df-admin-form :editing="isEditing" :loading="loading" @submit="submit" @cancel="$router.push({ name: 'admin-customers' })">

        <div class="email-compose-fields">
            <text-field horizontal label="Name" v-model="data.name" :validation="$v.data.name"/>
            <text-field horizontal label="Website" v-model="data.website" :validation="$v.data.website"/>
        </div>
        <div class="email-compose-fields">
            <text-field horizontal label="Strasse" v-model="data.street" :validation="$v.data.street"/>
            <text-field horizontal label="Postleitzahl" v-model="data.postcode" :validation="$v.data.postcode"/>
            <text-field horizontal label="Ort" v-model="data.location" :validation="$v.data.location"/>
            <select-menu horizontal label="Land" :options="countries" v-model="data.country" :validation="$v.data.country"/>
        </div>

    </df-admin-form>
</template>

<script>
    import { required, url } from 'vuelidate/lib/validators';
    import adminForm from '../../../../mixins/adminForm';
    import Customer from '../../../../models/Customer';
    import Countries from '../../../../data/Countries';

    export default {
        mixins: [adminForm],

        data: () => ({
            model: Customer,
            defaults: { },
        }),

        validations: {
            data: {
                name: { required },
                website: { required, url },
                street: { required },
                postcode: { required },
                location: { required },
                country: { required },
            },
        },

        asyncComputed: {
            countries: () => Countries.all(),
        },

        methods: {
            async submit() {
                if (await this.saveForm()) {
                    this.$router.push({ name: 'admin-customers' });
                }
            },
        },
    };
</script>
